import {cookie} from '../modules/cookie';

class PremiereReminder {
	constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvent();
	};

    _createElements(wrapper) {
        this.wrapper = wrapper;
        this.closeBtn = wrapper.querySelector('[data-PremiereReminder-close]');
        this.favBtn = wrapper.querySelector('[data-PremiereReminder-fav]');
        this.submitBtn = wrapper.querySelector('[data-PremiereReminder-submit]');
        this.rememberCheck = wrapper.querySelector('[data-PremiereReminder-remember]');
        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
    };

    _show(){
        this.wrapper.classList.remove('hidden');
        this._sendStatShow();
    }

    _hide(){
        this.wrapper.className += " hidden";
        setTimeout(()=> {
            this.wrapper.parentNode.removeChild(this.wrapper);
        }, 500)
    }
    _setCookie(){
        let self = this;

        if ( self.rememberCheck && self.rememberCheck.checked ) {
            cookie.setCookie('FAV_POPUP_HIDE', 1, {expires: 604800, path: '/'});
        } else {
            let cookieName = 'COUNTER_' + self.data.type.toUpperCase() + '_' + self.data.uid + '_NO';
            cookie.setCookie(cookieName, 1, {expires: 604800});
        }
    }
    _gaStatErrorHandler(event){
        console.error('GA не сработал: ' + event + ' PremiereReminder')
    }

    _sendStatShow(){

        let self = this;

        try {
            // ga('send', 'event', 'pop-up', 'show', 'pop-up_like-' + self.data.type.toLowerCase() + '_show', {nonInteraction: true});

            gtag('event', 'show', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_show',
                'nonInteraction': true
            });
        } catch(e){
            self._gaStatErrorHandler('появление попапа');
        }
    }
    _sendStatFavBtnPress(){

        let self = this;

        try {
            // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_like-' + self.data.type.toLowerCase() + '_ok-button_press', {nonInteraction: false})

            gtag('event', 'button-press', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_ok-button_press'
            });
        } catch(e){
            self._gaStatErrorHandler('нажатие на кнопку «в избранное»');
        }
    }
    _sendStatNoBtnPress(){

        let self = this;

        try {
            // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_like-' + self.data.type.toLowerCase() + '_no-buttom_press', {nonInteraction: false});

            gtag('event', 'button-press', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_no-buttom_press'
            });

        } catch(e){
            self._gaStatErrorHandler('нажатие на кнопку «нет, спасибо»');
        }
    }
    _sendStatCrossClick(){

        let self = this;

        try {
            // ga('send', 'event', 'pop-up', 'click', 'pop-up_like-' + self.data.type.toLowerCase() + '_close-icon_click', {nonInteraction: false});

            gtag('event', 'click', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_close-icon_click'
            });
        } catch(e){
            self._gaStatErrorHandler('клик на крестик');
        }
    }
    _sendStatCheckTrue(){

        let self = this;

        try {
            // ga('send', 'event', 'pop-up', 'click', 'pop-up_like-' + self.data.type.toLowerCase() + '_never-check_click', {nonInteraction: false});
            gtag('event', 'click', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_like-' + self.data.type.toLowerCase() + '_never-check_click'
            });
        } catch(e){
            self._gaStatErrorHandler('поставлена галка «больше не предлагать»');
        }
    }

    _addEvent(){
        let self = this;

        self._show();

        let close = function (e) {
            e.preventDefault();

            self._sendStatCrossClick();

            self._hide();

            // set cookie
            self._setCookie();
        };
        this.closeBtn.addEventListener('click', close, false);

        let submit = function (e) {
            e.preventDefault();

            self._sendStatNoBtnPress();

            self._hide();

            // set cookie
            self._setCookie();
        };
        if ( this.submitBtn ) {
	        this.submitBtn.addEventListener('click', submit, false);
        }
        
        this.favBtn.addEventListener('click', function () {
            self._sendStatFavBtnPress();
            setTimeout(()=> {
                self._hide();
            }, 500)
        }, false);

        if ( this.rememberCheck ) {
            this.rememberCheck.addEventListener('change', function () {
                if ( this.checked ) {
                    self._sendStatCheckTrue();
                }
            },false);
        }
    };

    _del(){};

}


export {PremiereReminder};



